import { transparentize } from 'polished';
import { componentInterface } from '@ardoq/component-interface';
import { referenceInterface } from '@ardoq/reference-interface';
import { GraphItem, hasColorAttributes } from '@ardoq/graph';
import { ensureContrast } from '@ardoq/color-helpers';
import { colors } from '@ardoq/design-tokens';
import { dataModelId } from './graphComponentUtil';
import { Edge } from 'graph/edge';
import { ComponentNode } from 'graph/ComponentNode';

const SELECTION_COLOR = '#7fffdc50';
/** although nodes and edges will sometimes _not_ be on a white background, they may in fact cross several different background colors for a single edge or node highlight. so, using white as a contrast color will have to suffice. */
const CONTRAST_BASE = colors.white950;
const getHighlightColor = (graphItem: GraphItem | ComponentNode | Edge) => {
  let isComponent,
    isReference = false;
  if (graphItem instanceof GraphItem) {
    isComponent = graphItem.isComponent();
    isReference = !isComponent && graphItem.isReference();
  } else if (graphItem instanceof ComponentNode) {
    isComponent = graphItem.isComponent();
  } else if (graphItem instanceof Edge) {
    isReference = true;
  }

  if (!isComponent && !isReference) {
    return SELECTION_COLOR;
  }

  const modelId = dataModelId(graphItem);
  const hasColorAttributesInClass = hasColorAttributes(graphItem);

  if (isComponent) {
    const fill = hasColorAttributesInClass
      ? graphItem.getCssColorAttributes().fill
      : componentInterface.getComponentDisplayColorAsSVGAttributes(modelId, {
          useAsBackgroundStyle: false,
        }).fill;
    if (fill) {
      return transparentize(0.7, ensureContrast(CONTRAST_BASE, fill));
    }
  }
  if (isReference) {
    const stroke = hasColorAttributesInClass
      ? graphItem.getCssColorAttributes().stroke
      : referenceInterface.getReferenceCssColors(modelId, {
          useAsBackgroundStyle: false,
        })?.stroke;
    if (stroke) {
      return transparentize(0.7, ensureContrast(CONTRAST_BASE, stroke));
    }
  }

  return SELECTION_COLOR;
};

export { getHighlightColor };
